import { createPlatformLocaleSwitch } from "@airange/ui/platform-locale-switch";
import { eduAdminLocaleController } from "../lib/locale";

export const LocaleSwitch = createPlatformLocaleSwitch({
  controller: eduAdminLocaleController,
});
